export const auth0Enabled = process.env.REACT_APP_ENABLE_AUTH0;
export const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
export const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const auth0RedirectUri = window.location.origin + '/authcb';
export const bobApiUrl = process.env.REACT_APP_API_BASE_URL;
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
